<template>
  <div class="agmt-info">
    <div class="box-radius-white">
      <h3 class="means-head-tit">
          <img src="../../../../static/assets/img/newCode/agmt/title-icon.png" />
          <span class="title__txt">
            交易权限开通
          </span>
      </h3>
      <div class="agmt-list">
        <div
          class="agmt-item"
          @click="() => onAgmtCheck(item)"
          :class="{ checked: item.checked, disabled: isDisablePage || item.disabled, disabledCheck: item.checked && (isDisablePage || item.disabled) }"
          v-for="item in showAgmtList"
          :key="item.CUST_AGMT_TYPE"
        >
          <div class="text-box">
            <span class="busiName">{{ item.BUSI_NAME }}</span>
            <span class="agmtText">{{ item.CUST_AGMT_TYPE_TEXT }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dict from "@/tools/dict";
import oppService from "@/service/opp-service";
export default {
  props: ["historyData", "oppBusiData", "isDisablePage"],
  data () {
    return {
      agmtList: [], // 协议列表
      OPEN_AGMT_FLAG_DATA: [], //已开通协议标识数据
      AGMT_OPEN_SUCCESS_LIST: [], //落地成功的权限数据
      permSurveyList: [], // 权限回访问题
      IMG_DATA: {}
    };
  },
  computed: {
    showAgmtList () {
      return _.filter(this.agmtList, item => !item.hide);
    },
    B_SNO () {
      return this.$storage.getSession(this.$definecfg.B_SNO) || "";
    }
  },
  mounted () {
    this.initData();
    consoleLog("mounted 111 this.agmtList",this.agmtList);
  },
  methods: {
    async initData () {
      let urls = ["OPP_BIZ_AGMT_TYPE", "CUST_AGMT_TYPE"],
        agmtList = [];
      let dictObj = await dict.getDictData(urls);
      this.$store.commit(this.$types.UPDATE_LOADING, "正在查询数据...");
      let custInfo = this.$storage.getJsonSession(this.$definecfg.CUSTOMER_INFO);
      let AGMT_RECHECK_SURVEY_SN = "53",
        ALLOW_HANDLE_AGMT_TYPE = oppService.getBusiCommonParamsFromCacheObjs("ALLOW_HANDLE_AGMT_TYPE");
      this.NEED_RECHECK_AGMT = oppService.getBusiCommonParamsFromCacheObjs("NEED_RECHECK_AGMT");
      AGMT_RECHECK_SURVEY_SN = oppService.getBusiCommonParamsFromCacheObjs("AGMT_RECHECK_SURVEY_SN") || "53";
      await this.getCustAgmtInfo(custInfo);
      await this.getSurveyColData(AGMT_RECHECK_SURVEY_SN);
      let bizAgmtTypeArr = dictObj.OPP_BIZ_AGMT_TYPE,
        custAgmtTypeArr = dictObj.CUST_AGMT_TYPE;
      _.each(bizAgmtTypeArr, obj => {
        //获取协议类型翻译数据
        var agmtTypeDictInfo = _.find(custAgmtTypeArr, function (v) {
            return obj.DICT_ITEM === v.DICT_ITEM;
          }),
          //拆分业务代码及业务名称
          busiCodeArr = obj.DICT_ITEM_NAME && obj.DICT_ITEM_NAME.split("-");

        !_.isEmpty(agmtTypeDictInfo) &&
          !_.isEmpty(busiCodeArr) && ALLOW_HANDLE_AGMT_TYPE.indexOf(obj.DICT_ITEM) > -1 &&
          agmtList.push({
            BUSI_CODE: busiCodeArr[0],
            BUSI_NAME: busiCodeArr[1],
            CUST_AGMT_TYPE: obj.DICT_ITEM,
            CUST_AGMT_TYPE_TEXT: obj.DICT_ITEM + "-" + agmtTypeDictInfo.DICT_ITEM_NAME,
            CUST_AGMT_TYPE_NAME: agmtTypeDictInfo.DICT_ITEM_NAME,
            checked: false,
            disabled: false
          });
      });
      this.agmtList = agmtList;
      this.loadData(_.get(this.historyData, "BIZ_DATA.TRDACCT_INFO_LIST", {}), _.get(this.historyData, "BIZ_DATA.AGMT_LIST", {}));
      this.$store.commit(this.$types.UPDATE_LOADING, false);
      consoleLog("mounted 22222 this.agmtList",this.agmtList);
    },
    //获取客户已签署协议
    async getCustAgmtInfo (custInfo) {
      let res = this.$syscfg.K_Request("Y3006014", {
        CUST_FNAME: custInfo.CUST_FNAME,
        ID_TYPE: custInfo.ID_TYPE,
        ID_CODE: custInfo.ID_CODE,
        CUST_CODE: custInfo.NEW_CUST_CODE
      });
      //0e-风险警示协议、0W-债券质押式融资回购协议 客户00、10板块已开通此权限，禁止重复开通！
      var openAgmtFlagData = {};
      let data = res.Data;
      if (res.Code != "0") {
        data = [];
      } else {
        _.each(data, obj => {
          if (["0e", "0W"].includes(obj.CUST_AGMT_TYPE) && ["00", "10"].includes(obj.STKBD)) {
            this["isOpenAgmt" + obj.CUST_AGMT_TYPE + obj.STKBD] = true;
            //禁止开通对应板块的协议
            openAgmtFlagData["BAN_OPEN_AGMT_" + obj.CUST_AGMT_TYPE + "_" + obj.STKBD] = "1";
            //已开通权限的证券账户
            openAgmtFlagData["OPEN_AGMT_ACCT_" + obj.CUST_AGMT_TYPE + "_" + obj.STKBD] = [];
            openAgmtFlagData["OPEN_AGMT_ACCT_" + obj.CUST_AGMT_TYPE + "_" + obj.STKBD].push(obj.TRDACCT);
          }
        });
      }
      _.each(["0W"], agmt => {
        openAgmtFlagData["BAN_OPEN_AGMT_" + agmt] = this["isOpenAgmt" + agmt + "00"] && this["isOpenAgmt" + agmt + "10"] ? "1" : "0";
      });
      //获取已开通权限标识
      this.OPEN_AGMT_FLAG_DATA = openAgmtFlagData;
    },
    async getSurveyColData (SURVEY_SN, VERSION) {
      let res = await this.$syscfg.K_Request("Y3000902", {
        SURVEY_SN: SURVEY_SN,
        //送 “1”：风险测评编号4，第二题年收入返回 COL_NAME:"SURVEY_INCOME" COL_VALUE对应值的答案
        INCOME_FLAG: "1",
        //版本号
        VERSION: VERSION || ""
      });
      if (res.Code == 0) {
        if (res.Data && res.Data.length > 0) {
          this.permSurveyList = res.Data;
        }
      }
    },
    loadData (TRDACCT_INFO_LIST, agmtInfo = {}) {
      let that = this;
      //开通深A账户、沪A账户及标识
      that.isOpenA00 = false;
      that.isOpenA10 = false;
      that.openAcct00 = "";
      that.openAcct10 = "";
      _.each(TRDACCT_INFO_LIST, obj => {
        //是否开通深A账户、沪A账户
        "$SZA" === obj.OP_TYPE && (that.isOpenA00 = true) && (that.openAcct00 = obj.TRDACCT);
        "$SHA" === obj.OP_TYPE && (that.isOpenA10 = true) && (that.openAcct10 = obj.TRDACCT);
      });
      //update 20260423
      _.each(that.agmtList, item => {
        //没有选择沪市时，科创板、科创成长层权限隐藏不显示；
        ["2C", "2U"].includes(item.CUST_AGMT_TYPE) && (item.hide = !that.isOpenA10);
        //没有选择深市时，创业板、北交所、深市退市整理权限隐藏不显示；
        ["2k", "2m", "3b"].includes(item.CUST_AGMT_TYPE) && (item.hide = !that.isOpenA00);
      });
      _.each(that.agmtList, obj => {
        if (
          !!_.find(that.AGMT_OPEN_SUCCESS_LIST, function (v) {
            return obj.CUST_AGMT_TYPE === v.CUST_AGMT_TYPE;
          })
        ) {
          obj.disabled = true;
        } else {
          obj.disabled = false;
        }
      });
      // 回填历史数据
      _.each(agmtInfo || [], item => {
        if (!item.hide ||item.hide =="false") {
          let agmtItem = _.find(that.agmtList, obj => obj.CUST_AGMT_TYPE == item.CUST_AGMT_TYPE);
          if (agmtItem) {
            agmtItem.checked = true;
            that.agmtCheckLink(agmtItem.checked, [agmtItem]);
          }
        }
      });
    },
    onAgmtCheck (item) {
      if (this.isDisablePage || item.disabled) {
        return;
      }
      item.checked = !item.checked;
      this.agmtCheckLink(item.checked, [item]);
    },
    agmtCheckLink (isCheck, rowData) {
      //获取是否勾选17-质押协议回购融入协议、18-质押协议回购融出协议、0W-债券质押式融资回购协议、2E-特定债券协议
      let checkedAgmt = _.filter(this.agmtList, item => item.checked == true);
      let bondRepoAgmtObj = _.find(checkedAgmt, function (obj) {
        return ["17", "18", "0W", "2E"].includes(obj.CUST_AGMT_TYPE);
      });
      //获取11-债券专业投资者(新)所在行下标
      let agmt11 = _.find(this.agmtList, item => item.CUST_AGMT_TYPE == "11");
      let agmt2C = _.find(this.agmtList, item => item.CUST_AGMT_TYPE == "2C");

      //是否成功开通11-债券专业投资者(新)
      let isSuccOpenAgmt11 = !!_.find(this.AGMT_OPEN_SUCCESS_LIST, function (v) {
        return "11" === v.CUST_AGMT_TYPE;
      });
      let isSuccOpenAgmt2C = !!_.find(this.AGMT_OPEN_SUCCESS_LIST, function (v) {
        return "2C" === v.CUST_AGMT_TYPE;
      });
      _.each(rowData, item => {
        //11-债券专业投资者(新)、17-质押协议回购融入协议、18-质押协议回购融出协议、0W-债券质押式融资回购协议、2E-特定债券协议
        if (["17", "18", "0W", "2E"].includes(item.CUST_AGMT_TYPE) && agmt11) {
          //勾选17、18、0W协议则联动勾选11且置灰不可修改
          if (isCheck) {
            agmt11.checked = true;
            agmt11.disabled = true;
          }
          //取消勾选17、18、0W、2E协议且未成功开通11-债券专业投资者(新)则联动启用17、18、0W、2E协议可修改不联动取消其勾选框
          if (!isCheck && !isSuccOpenAgmt11 && _.isEmpty(bondRepoAgmtObj)) {
            agmt11.disabled = false;
          }
        }
        if(item.CUST_AGMT_TYPE == "2U" && agmt2C){
          if (isCheck) {
            agmt2C.checked = true;
            agmt2C.disabled = true;
          }
          if (!isCheck && !isSuccOpenAgmt2C) {
            agmt2C.disabled = false;
          }
        }
      });
      //客户的证件号码ID已开通对应板块的0W-债券质押式融资回购协议、0e-风险警示协议，则取消勾选且置灰不可重复开通
      this.setDisable0W0e(rowData, isCheck);
    },
    setDisable0W0e (rowData, isCheck) {
      //已开通协议的证券账户集合
      var that = this, open0eAcctArr = [], contactInfo = that.historyData.BIZ_DATA && that.historyData.BIZ_DATA.CONTACT_INFO || {};
      that.isDisable00 = false;
      that.isDisable10 = false;
      _.each(rowData, function (obj) {
        //update 20260423 OPPCP-35720 限制解限改造项目-针对种子基金、代销产品新增集中交易和融资融券的限制/解限：
        //“0e-风险警示协议、2m-北交所协议、新三板协议（2h-一类合格投资者、2i-二类合格投资者、2j-三类合格投资者）” 且 风险因素包含“J-资管投资产品、K-代销产品、L-种子基金投向产品”之一，则置灰勾选框不能勾选
        if (["0e","2m","2h","2i","2j"].includes(obj.CUST_AGMT_TYPE) && /[JKL]/.test(contactInfo.RISK_FACTOR || "")) {
          obj.disabled = true;
          obj.checked = false;
          that.alert("禁止开通此权限，如有疑问，请联系产品投资人！");
        }
        //没有选择深市时，创业板、北交所、深市退市整理权限禁用；
        if (!["0e", "0W"].includes(obj.CUST_AGMT_TYPE)) {
          return true;
        }
        _.each(["00", "10"], function (stkbd) {
          /* update 20230302 OPPCP-20415【P】一人多户产品开户-落地步骤未开通深市0e但是表单有深市0e
           * 修改判断是否开通逻辑为：0e-风险警示协议判断证券账户是否已开通过，已开通则禁用复选框不可勾选
           */
          if (obj.CUST_AGMT_TYPE == "0e") {
            //已开通0e-风险警示协议的证券账户集合
            if (
              that.OPEN_AGMT_FLAG_DATA["OPEN_AGMT_ACCT_" + obj.CUST_AGMT_TYPE + "_" + stkbd] &&
              that.OPEN_AGMT_FLAG_DATA["OPEN_AGMT_ACCT_" + obj.CUST_AGMT_TYPE + "_" + stkbd].includes(that["openAcct" + stkbd])
            ) {
              that.OPEN_AGMT_FLAG_DATA["BAN_OPEN_AGMT_" + obj.CUST_AGMT_TYPE + "_" + stkbd] = "1";
              that["banOpenAgmt0e" + stkbd] = true;
              open0eAcctArr.push(that["openAcct" + stkbd]);
            } else {
              that.OPEN_AGMT_FLAG_DATA["BAN_OPEN_AGMT_" + obj.CUST_AGMT_TYPE + "_" + stkbd] = "0";
              that["banOpenAgmt0e" + stkbd] = false;
            }
          }
          //只勾选深A或只勾选沪A且对应板块已开通协议则需禁用复选框不可勾选
          !(that.isOpenA00 && that.isOpenA10) && (that["isDisable" + stkbd] = that["isOpenA" + stkbd] && "1" === that.OPEN_AGMT_FLAG_DATA["BAN_OPEN_AGMT_" + obj.CUST_AGMT_TYPE + "_" + stkbd]);
        });
        //0e-风险警示协议判断深A和沪A是否都禁用
        if (obj.CUST_AGMT_TYPE == "0e") {
          that.OPEN_AGMT_FLAG_DATA["BAN_OPEN_AGMT_" + obj.CUST_AGMT_TYPE] = that.banOpenAgmt0e00 && that.banOpenAgmt0e10 ? "1" : "0";
        }
        /*
         * 1、只勾选深A且深A已开通0W协议则需禁用复选框不可勾选
         * 2、只勾选沪A且沪A已开通0W协议则需禁用复选框不可勾选
         * 3、同时勾选深A、沪A且深A、沪A都已开通0W协议则需禁用复选框不可勾选
         * 4、只加挂深A且深A已开通0e协议则需禁用复选框不可勾选
         * 5、只加挂沪A且沪A已开通0e协议则需禁用复选框不可勾选
         * 6、同时加挂深A、沪A且深A、沪A都已开通0e协议则需禁用复选框不可勾选
         * 除以上禁用情况外都可勾选，审核端会根据所选账户进行过滤，只保留未开通的数据
         */
        if (that.isDisable00 || that.isDisable10 || "1" === that.OPEN_AGMT_FLAG_DATA["BAN_OPEN_AGMT_" + obj.CUST_AGMT_TYPE]) {
          isCheck && (obj.checked = false);
          // obj.disabled = true;
          that.alert((["0e"].includes(obj.CUST_AGMT_TYPE) ? "当前客户的证券账户" + open0eAcctArr + "已签署" : "当前客户的证件号码ID已签署") + obj.CUST_AGMT_TYPE_NAME + "，禁止重复签署！");
        } else {
          obj.disabled = false;
        }
      });
    },
    validate (_this) {

    },
    beforeSave (_this, params) {
      let that = _this.$refs.agmtInfo;
      let agmtCheckRows = _.filter(that.agmtList, item => item.checked == true);
      let checkedArr = _.map(agmtCheckRows, "CUST_AGMT_TYPE");
      let ZY_CUST_AGMT_TYPE_TEXT = [];
      if (checkedArr.includes("17")) {
        ZY_CUST_AGMT_TYPE_TEXT.push("质押式协议回购融入协议");
      }
      if (checkedArr.includes("18")) {
        ZY_CUST_AGMT_TYPE_TEXT.push("质押式协议回购融出协议");
      }
      let resultData = {
        CUST_RECHECK_RESULT_DETAIL: that.permSurveyList,
        custRecheckResultArr: [{}, {}],
        //已开通协议标识数据
        OPEN_AGMT_FLAG_DATA: that.OPEN_AGMT_FLAG_DATA,
        //需开通的协议、是否开通深A、是否开通沪A，用于影像条件配置
        AGMT_TYPE_IMG: checkedArr || [],
        IS_OPEN_SZA: that.isOpenA00 ? "1" : "0",
        IS_OPEN_SHA: that.isOpenA10 ? "1" : "0",
        ZY_CUST_AGMT_TYPE_TEXT: ZY_CUST_AGMT_TYPE_TEXT.join(","),
        ALL_CUST_AGMT_TYPE_TEXT: _.map(agmtCheckRows, "BUSI_NAME").join(",")
      };
      let STKBD_TRDACCT = {};
      if (_.get(that.historyData, "IMG_DATA.SZ_ACCT_TEXT", "")) {
        if (_.isEmpty(that.OPEN_AGMT_FLAG_DATA) || "1" != that.OPEN_AGMT_FLAG_DATA.BAN_OPEN_AGMT_0e_00) {
          STKBD_TRDACCT.SZ_ACCT_TEXT = that.historyData.IMG_DATA.SZ_ACCT;
        }
      }
      if (_.get(that.historyData, "IMG_DATA.SH_ACCT_TEXT", "")) {
        if (_.isEmpty(that.OPEN_AGMT_FLAG_DATA) || "1" != that.OPEN_AGMT_FLAG_DATA.BAN_OPEN_AGMT_0e_10) {
          STKBD_TRDACCT.SH_ACCT_TEXT = that.historyData.IMG_DATA.SH_ACCT;
        }
      }
      resultData.STKBD_TRDACCT = STKBD_TRDACCT;
      //需要开通的权限在需要回访的协议的公参里面则显示权限回访页签
      if (!_.isEmpty(_.intersection(checkedArr || [], that.NEED_RECHECK_AGMT.split(",")))) {
        resultData.CUST_RECHECK_RESULT_DETAIL = that.permSurveyList;
        resultData.custRecheckResultArr = [{}, {}];
      } else {
        resultData.CUST_RECHECK_RESULT_DETAIL = [];
        resultData.custRecheckResultArr = [];
      }
      params.BIZ_DATA.AGMT_LIST = agmtCheckRows;
      if (!params.IMG_DATA) {
        params.IMG_DATA = {};
      }
      Object.assign(params.IMG_DATA, resultData);
    }
  }
};
</script>
<style scoped>
.agmt-info {
  background: #fff;
}
.agmt-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding-left: 5%;
}
.agmt-list .agmt-item {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f4f6f8;
  width: 47%;
  height: 0.92rem;
  /* margin: 0.2rem 0.1rem; */
  padding-left: 0.5rem;
  position: relative;
  padding: 0 0.5rem;
  width: 500px;
  margin: 0 150px 24px 0;
  height: 70px;
}
.agmt-list .checked {
  background: #fffbf4;
  border: 2px solid rgba(229, 190, 117, 1);
}
.agmt-list .disabled {
  background: #fafafa;
  border: none;
}
.agmt-list .checked::after {
  content: "";
  width: 0.36rem;
  height: 0.36rem;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 9;
  background: url("../../../../static/assets/img/newCode/agmt/icon-checkbox-corner-on.svg");
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: cover;
}
.agmt-list .disabledCheck::after {
  content: "";
  width: 0.36rem;
  height: 0.36rem;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 9;
  background: url("../../../../static/assets/img/newCode/agmt/icon-checkbox-corner-on-disable.svg");
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: cover;
}

.agmt-list .disabledCheck {
  border: 2px solid #f9ebd3;
}

.agmt-list .agmt-item .check-box {
  width: 0.6rem;
  text-align: center;
}
.agmt-list .agmt-item .check-box .ivu-checkbox-checked .ivu-checkbox-inner {
  background: #e5be75;
  border: none;
}
.agmt-list .agmt-item .text-box {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.agmt-list .agmt-item .text-box .busiName {
  font-family: PingFangSC-Regular;
  font-size: 0.16rem;
  color: #17233d;
  letter-spacing: 0;
  font-weight: 400;
}

.agmt-list .agmt-item .text-box .agmtText {
  font-family: PingFangSC-Regular;
  font-size: 0.14rem;
  color: #a29e9e;
  letter-spacing: 0;
}
.agmt-list .disabled .text-box .busiName {
  color: #a29e9e;
}
</style>



// WEBPACK FOOTER //
// src/business/businessFile/QS421/agmtInfo.vue